import { Body, Button, dsColors, FlexBox, Headline } from '@Backlot-Cars/archie';
import List from 'components/List';
import PublicLayout from 'components/PublicSiteLayout/Base';
import CenteredBox from 'components/PublicSiteLayout/CenteredBox';
import { CORPORATE_SITE_URL } from 'helpers/externalRoutes';
import { Trans, useTranslation } from 'next-i18next';
import { DISCLAIMER_TYPES } from './disclaimerTypes';
import { SanitizedHtmlBody } from 'components/SanitizedHtmlBody';

const getTranslationPrefixForType = ({ disclaimerType }) => {
	if (disclaimerType === DISCLAIMER_TYPES.CONNECT_ACCOUNTS) {
		return 'connectAccount';
	} else if (disclaimerType === DISCLAIMER_TYPES.ADDITIONAL_SECURITY) {
		return 'additionalSecurity';
	}
};

const BodyWithLink = ({ i18nKey, href, onLinkClick, onLinkDisabled }) => {
	return (
		<Body>
			<Trans
				i18nKey={i18nKey}
				components={[
					<Button
						key="link"
						labelColor={dsColors.colorBrand.primary}
						variant="text"
						href={href}
						onClick={onLinkClick}
						disabled={onLinkDisabled}
					/>,
				]}
			/>
		</Body>
	);
};

const WhatNeedsToBeDone = ({ t, prefix }) => (
	<FlexBox flexDirection="column">
		<Body bold>{t(`oktaForceLink.${prefix}.whatToDo`)}</Body>
		<List ordered gap="xxs" margin="md">
			<Body as="li">{t(`oktaForceLink.${prefix}.step1`)}</Body>
			<Body as="li">{t(`oktaForceLink.${prefix}.step2`)}</Body>
			<Body as="li">{t(`oktaForceLink.${prefix}.step3`)}</Body>
			<Body as="li">{t(`oktaForceLink.${prefix}.step4`)}</Body>
		</List>
	</FlexBox>
);

const ConnectOkta = ({ disclaimer }) => {
	const { t } = useTranslation('okta');
	const prefix = getTranslationPrefixForType({ disclaimerType: disclaimer });

	return (
		<PublicLayout>
			<CenteredBox verticallyCentered>
				<FlexBox flexDirection="column" gap="md" maxWidth={600}>
					<Headline size="H3" color={dsColors.colorBrand.secondary}>
						{t(`oktaForceLink.${prefix}.title`)}
					</Headline>
					<BodyWithLink i18nKey={`okta:oktaForceLink.${prefix}.description`} href={CORPORATE_SITE_URL} />
					<WhatNeedsToBeDone t={t} prefix={prefix} />
					<SanitizedHtmlBody variant="primary" html={t(`okta:oktaForceLink.didNotReceiveEmail`)} />
				</FlexBox>
			</CenteredBox>
		</PublicLayout>
	);
};

export default ConnectOkta;
